export const namespace = 'top-factors-map';
const ns = (name) => `${namespace}/${name}`;

export const SELECT_ZIP_CODE = ns('SELECT_ZIP_CODE');
export const SHOW_MSA_ZIP_CODE_VALUES = ns('SHOW_MSA_ZIP_CODE_VALUES');
